import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { InteractiveDragItem } from './interactive-drag.style';

type InteractiveDragLayerContainerProps = {
  $isDragging?: boolean;
};
export const InteractiveDragLayerContainer = styled.div<InteractiveDragLayerContainerProps>`
  cursor: grabbing;
  position: fixed;
  pointer-events: none;
  left: 0;
  top: 0;
  height: ${rem(124)};
  width: ${rem(124)};
  transition:
    width 0.3s ease-out,
    height 0.3s ease-out;
  z-index: 2000;

  ${InteractiveDragItem} {
    opacity: 0.9;
    height: 100%;
  }
`;
